import React from "react";
import { IoClose } from "react-icons/io5";
import Modal from "react-modal";

Modal.setAppElement("#root");

function FinCompanyPurchaseOrderInvoiceDetails({ open, onClose, data }) {
  if (!open || !data) return null;

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 9999,
        },
        content: {
          width: "85%",
          height: "85%",
          margin: "auto",
          borderRadius: "10px",
          padding: 0,
          inset: "60px",
          overflow: "hidden",
        },
      }}
    >
      <div className="flex flex-col h-full">
        {/* Sticky Header */}
        <div className="sticky top-0 bg-white-A700 border-b px-4 py-3 z-20 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-800">
            Purchase Invoice Details
          </h2>

          <button
            onClick={onClose}
            className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 text-gray-700"
          >
            <IoClose size={22} />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="p-4 overflow-y-auto space-y-4 text-sm">
          {/* Basic Details */}
          <Section title="Basic Details">
            <Grid cols={4}>
              <Detail label="Invoice Number" value={data.invoice_number} />
              <Detail label="Invoice Date" value={data.invoice_date} />
              <Detail label="Posting Date" value={data.posting_date} />
              <Detail label="Due Date" value={data.due_date} />
            </Grid>
          </Section>

          {/* Supplier Info */}
          <Section title="Supplier & Order Info">
            <Grid cols={4}>
              <Detail label="Supplier Name" value={data.supplier_name} />
              <Detail label="Supplier Code" value={data.supplier_code} />
              <Detail
                label="Purchase Order Code"
                value={data.purchase_order_code || "-"}
              />
              <Detail label="GRN No" value={data.grn_no || "-"} />
            </Grid>
          </Section>

          {/* Status */}
          <Section title="Category & Status">
            <Grid cols={3}>
              <Detail
                label="Invoice Category"
                value={data.invoice_category_name}
              />
              {/* <Detail label="Status" value={data.invoice_status_name} /> */}
              <div>
                <p className="text-gray-500 text-sm">Status</p>
                <p className="font-medium text-sm text-green-800">
                  {data.invoice_status_name}
                </p>
              </div>
              <Detail label="Document Type" value={data.fin_doc_type_name} />
            </Grid>
          </Section>

          {/* Amount Section */}
          <Section title="Amount Summary">
            <Grid cols={4}>
              <Detail
                label="Total Item Amount"
                value={data.total_item_amount}
              />
              <Detail label="Total Tax Amount" value={data.total_tax_amount} />
              <Detail
                label="Total Invoice Amount"
                value={data.total_invoice_amount}
              />
              <Detail label="TDS Code" value={data.tds_code} />
              <Detail label="TDS Percent" value={data.tds_percent} />
              <Detail label="TDS Amount" value={data.tds_amount} />
              <Detail label="RCM Code" value={data.rcm_code || "-"} />
              <Detail label="RCM Percent" value={data.rcm_percent} />
              <Detail label="RCM Amount" value={data.rcm_amount} />
            </Grid>
          </Section>

          {/* Remarks */}
          <Section title="Remarks">
            <p className="p-2 border rounded bg-white-A700 text-gray-700">
              {data.remarks || "No remarks"}
            </p>
          </Section>

          {/* Items Table */}
          <Section title="Invoice Items">
            {/* <div className="overflow-x-auto border rounded-lg bg-white-A700">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-100 text-gray-600 sticky top-0 z-10">
                  <tr>
                    <Th>Sr</Th>
                    <Th>Item Name</Th>

                    <Th className="text-right">Qty</Th>
                    <Th className="text-right">Rate</Th>
                    <Th className="text-right">Tax Amount</Th>
                    <Th className="text-right">Total</Th>
                  </tr>
                </thead>

                <tbody className="divide-y">
                  {data.items?.map((item, i) => (
                    <tr key={item.id}>
                      <Td>{i + 1}</Td>
                      <Td>{item.item_name}</Td>

                      <Td className="text-right">{item.quantity}</Td>
                      <Td className="text-right">{item.cost_price}</Td>
                      <Td className="text-right">{item.tax_amount}</Td>
                      <Td className="text-right">{item.total_amount}</Td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div> */}

            <div className="overflow-x-auto border rounded-lg bg-white-A700">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-100 text-gray-600 sticky top-0 z-10">
                  <tr>
                    <Th>Sr</Th>
                    <Th>Item (Code)</Th>
                    <Th className="text-right">Qty</Th>
                    <Th className="text-right">Rate</Th>

                    {/* Separate GST Columns */}
                    <Th className="text-right">CGST</Th>
                    <Th className="text-right">SGST</Th>
                    <Th className="text-right">IGST</Th>

                    <Th className="text-right">Total</Th>
                  </tr>
                </thead>

                <tbody className="divide-y">
                  {data.items?.map((item, i) => (
                    <tr key={item.id}>
                      <Td>{i + 1}</Td>

                      {/* Item + Code */}
                      <Td>
                        <div className="font-medium">
                          {item.item_name}{" "}
                          <span className="text-xs text-gray-500">
                            ({item.code})
                          </span>
                        </div>
                      </Td>

                      <Td className="text-right text-xs">{item.quantity}</Td>
                      <Td className="text-right text-xs">{item.cost_price}</Td>

                      {/* Separate GST Columns */}
                      {/* CGST Amount + Percent */}
                      <Td className="text-right text-xs">
                        {item.cgst_amount} ({item.cgst_percent}%)
                      </Td>

                      {/* SGST Amount + Percent */}
                      <Td className="text-right text-xs">
                        {item.sgst_amount} ({item.sgst_percent}%)
                      </Td>

                      {/* IGST Amount + Percent */}
                      <Td className="text-right text-xs">
                        {item.igst_amount} ({item.igst_percent}%)
                      </Td>

                      <Td className="text-right font-medium text-xs">
                        {item.total_amount}
                      </Td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Section>
        </div>
      </div>
    </Modal>
  );
}

const Section = ({ title, children }) => (
  <div className="bg-gray-50 border rounded-lg p-2 shadow-sm">
    <h3 className="font-semibold text-gray-700 mb-2 text-base">{title}</h3>
    {children}
  </div>
);

const Grid = ({ cols = 2, children }) => (
  <div className={`grid grid-cols-4 md:grid-cols-${cols} gap-3`}>
    {children}
  </div>
);

const Detail = ({ label, value }) => (
  <div>
    <p className="text-gray-600 text-sm">{label}</p>
    <p className="font-medium text-sm text-gray-800">{value}</p>
  </div>
);

const Th = ({ children, className }) => (
  <th className={`px-3 py-2 text-left font-medium ${className}`}>{children}</th>
);

const Td = ({ children, className }) => (
  <td className={`px-3 py-2 ${className}`}>{children}</td>
);

export default FinCompanyPurchaseOrderInvoiceDetails;
